import React from "react";

const ListofAuthorities = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>List of Authorities</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>FIRST APPELLATE AUTHORITY</th>
                <th>COMPANY SECRETARY</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="bold center-align" colspan="2">
                  HEAD OFFICE
                </td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Chief Finance &amp; Accounts Officer</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Assistant Purchase Officer</td>
              </tr>
              <tr>
                <td className="bold center-align" colspan="2">
                  REGIONAL OFFICES / MARKETING OFFICE
                </td>
              </tr>
              <tr>
                <td colspan="2">SIRSA</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Accounts Officer / Section Officer</td>
              </tr>
              <tr>
                <td colspan="2">HISAR</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Accounts Officer / Section Officer / Accounts Assistant</td>
              </tr>
              <tr>
                <td colspan="2">PATAUDI</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Section Officer</td>
              </tr>
              <tr>
                <td colspan="2">TOHANA</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Accounts Officer / Section Officer</td>
              </tr>
              <tr>
                <td colspan="2">YAMUNA NAGAR</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Accounts Officer / Section Officer</td>
              </tr>
              <tr>
                <td colspan="2">UMRI</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Accounts Officer / Section Officer</td>
              </tr>
              <tr>
                <td colspan="2">BHIWANI</td>
              </tr>
              <tr>
                <td>Public Information Officer</td>
                <td>Unit Incharge</td>
              </tr>
              <tr>
                <td>Asstt. Public Information Officer</td>
                <td>Section Officer</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListofAuthorities;
